<template>
  <div id="app">
    <div class="wrapper">
      <router-view :key="$route.fullPath"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body {
    font-family: sans-serif;
    font-size: 14px;
  }
  .wrapper {
    max-width: 980px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue